import React from 'react'
import PropTypes from 'prop-types'
import './styles'

import logo from '/assets/images/universe.png'
import okta from '/assets/images/okta.png'

import FaLock from 'react-icons/lib/fa/lock'

import { withAuth } from '@okta/okta-react'
import flash from '/lib/flash'

import Turnstile from '/components/turnstile'


export default \
withAuth \
class SignIn extends React.Component
  @propTypes:
    login:    PropTypes.func.isRequired

  constructor: ->
    super arguments...
    @state = 
      username: null
      password: null
      mode: null
      token: null

  signIn: (evt)->
    evt.preventDefault()
    
    @props.login(
      @state.username,
      @state.password,
      @state.mode,
      @state.token
    )
    .catch (err)->
      response = err?.responseJSON
      if response?.failed_attempts?
        remaining = 5 - response.failed_attempts
        flash.error "Login failed. #{remaining} attempt#{if remaining is 1 then '' else 's'} remaining."
      else
        flash.error response?.error_description or "Login failed. Please try again."
    false

  signInOkta: =>
    localStorage.okta_redirect = window.location.href
    @props.auth.login '/'

  render: ->
    <div className="SignIn">

      <FaLock className='lock-icon'/>

      <img className="logo" src={logo} style={width: 150, marginBottom: 50, marginTop: 25}/>

      <form className="form sign-in-form" onSubmit={@signIn.bind(@)}>

        <div className="form-group">
          <label htmlFor="email" className="control-label">Email</label>
          <input
            type="email"
            className="form-control"
            autoFocus
            name="email"
            onChange={(evt)=>@setState username: evt.target.value}
            placeholder="admin@universe.com"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password" className="control-label">Password</label>
          <input
            type="password"
            className="form-control"
            name="password"
            onChange={(evt)=>@setState password: evt.target.value}
            placeholder="password"
          />
        </div>

        <Turnstile
          onChange={(mode, token)=> @setState {mode, token}}
          onError={(err)=> flash.error err}
        />

        <input
          type='submit'
          className='btn btn-md btn-primary'
          value='Sign In'
          disabled={not (@state.username and @state.password)}
        />

      </form>

      <div className="help-text">
        <a onClick={@signInOkta} className="btn btn-default">
          Sign in with
          <img className="okta" src={okta}/>
        </a>
      </div>

    </div>
